import message from "antd/lib/message";
import React from "react";
import styled from "styled-components";
import copyIcon from "./copyicon.svg";
const WRAPPER = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: center;
`;

const TEXT_WRAPPER = styled.span`
	margin-right: 5px;
	font-weight: 700;
	${({ color }) => color && `color: ${color};`}
`;

export default function IdView({ successMsg, failureMsg, id, length = 13, color }) {
	function copy() {
		navigator.clipboard.writeText(id).then(
			function () {
				message.success(successMsg || "COPIED");
			},
			function () {
				message.error(failureMsg || "NOT COPIED!");
			}
		);
	}
	return (
		<WRAPPER>
			<TEXT_WRAPPER color={color}>
				{id.slice(0, length)}
				{id?.length > length ? "..." : ""}
			</TEXT_WRAPPER>
			<img
				width={17}
				src={copyIcon}
				onClick={copy}
			/>
		</WRAPPER>
	);
}
